import React from 'react';

const About = () => {
    return (
        <div>
            <h3>this is about</h3>
        </div>
    );
};

export default About;